import { createSlice } from '@reduxjs/toolkit';

import { RootState } from '$store/rootReducer';
import { AICapsState, SetAICapsAction } from './interface';

const initialState: AICapsState = {
  suggest: false,
};

export const { actions, reducer } = createSlice({
  name: 'aiCaps',
  initialState,
  reducers: {
    set(state, action: SetAICapsAction) {
      const next = action.payload || {};
      state.suggest = !!next.suggest;
    },
  },
});

export { reducer as aiCapsReducer, actions as aiCapsActions };

export const aiCapsSelector = (state: RootState): AICapsState => state.aiCaps;
